import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase/client";
import type { UsefulInfoSheetReply } from "./usefulInfoNationalityCells";

/** Server retrieves only from the canonical private sheet; no credential in client. */
export async function fetchUsefulInfoFromSheet(
  destinationCode: string, nationalities: readonly string[]
): Promise<UsefulInfoSheetReply> {
  const callable = httpsCallable<
    { destinationCode: string; nationalities: string[] }, UsefulInfoSheetReply
  >(functions, "getUsefulInfoFromSheet", { timeout: 45_000 });
  const result = await callable({ destinationCode, nationalities: [...nationalities] });
  return result.data;
}
